import React, { Fragment, useState } from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { useDataProvider, useNotify } from 'react-admin';
import ConfirmDialog from 'components/ConfirmDialog';
import { Image } from '../types';

const useStyles = makeStyles({
  img: {
    marginTop: '10px',
    width: '500px',
    marginRight: '10px',
    cursor: 'pointer',
  },
});

interface ImageViewerProps {
  open: boolean;
  handleClose: () => void;
  imageSelected: Pick<Image, 'id' | 'fileUrl'> | undefined;
  isViewPhotos?: boolean;
  getJobPhasePhotos?: () => void;
}

const deletePhoto = async (
  dataProvider: any,
  jobPhasePhotoId: string,
  setOpenConfirmDelete: (open: boolean) => void,
  notify: ReturnType<typeof useNotify>,
  getJobPhasePhotos: () => void,
  handleClose: () => void,
) => {
  try {
    await dataProvider.delete('job-phase-photo', {
      id: jobPhasePhotoId,
    });
    notify('Success on Remove!');
  } catch {
    notify(`Error when try to remove the photo`, 'warning');
  }
  getJobPhasePhotos();
  setOpenConfirmDelete(false);
  handleClose();
};

export const ImageViewer = (props: ImageViewerProps) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  return (
    <Fragment>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Image Viewer</DialogTitle>
        <DialogContent>
          <Box>
            {props.imageSelected && (
              <img className={classes.img} src={props.imageSelected.fileUrl} />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            Close
          </Button>
          {!props.isViewPhotos && (
            <Button
              onClick={() => setOpenConfirmDelete(true)}
              color="primary"
              autoFocus
            >
              Delete Photo
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={openConfirmDelete}
        title={`Are you sure that you want to delete this photo?`}
        handleClose={() => setOpenConfirmDelete(false)}
        onConfirm={() =>
          props.imageSelected &&
          props.getJobPhasePhotos &&
          deletePhoto(
            dataProvider,
            props.imageSelected.id,
            setOpenConfirmDelete,
            notify,
            props.getJobPhasePhotos,
            props.handleClose,
          )
        }
      />
    </Fragment>
  );
};

export default ImageViewer;
